import { FadeOut } from "slotworks/graphics/animation/base-animations";
import Layers from "slotworks/graphics/layers/layers";
import RevolverWinTransitions from "slotworks/integration/revolver/transitions/revolver-win-transitions";
import SoundManager from "slotworks/sound/sound-manager";
import Contract from "slotworks/utils/contract";
import Point from "slotworks/utils/geom/point";
import { parallel, sequence } from "slotworks/utils/race-utils";
import Timer from "slotworks/utils/timer";
import * as TweenJS from "slotworks/utils/tween";

export default class MegaWinTransitions extends RevolverWinTransitions {
    public EXPLOSION_TIME: number = 5500;
    public TEXT_ZOOM: number = 1.3;

    private mega: PIXI.Sprite;

    public in(): Contract<void> {
        return new Contract((resolve) => {

            this.mega = Layers.CelebrationContent.getSprite("mega");

            this.inResolve = resolve;

            this.timers = [];

            parallel([
                () => Contract.wrap(() => {
                    SoundManager.customEvent("mega_win");
                }),
                () => this.introduce(this.mega, this.EXPLODE_DELAY, new Point(0.5, 1), 0.5),
                () => this.introduce(RevolverWinTransitions.winText, this.EXPLODE_DELAY, new Point(0.5, 1), 0.5),
                () => this.introduce(RevolverWinTransitions.winValue, this.EXPLODE_DELAY, new Point(0.5, 0.5), 0.5)
            ]).then(() => {
                RevolverWinTransitions.winTextHover.onLoop(() => {
                    this.zoomTextIn(this.TEXT_ZOOM, this.EXPLOSION_TIME).execute();
                    if (RevolverWinTransitions.winText.scale.x === 1) {
                        this.endlessHover(this.mega);
                        RevolverWinTransitions.winTextHover.onLoop(null);
                    }
                });

                this.resolveIn();
            });

            this.timers.push(Timer.setTimeout(() => {
                this.explodeAgain(true);
            }, this.EXPLOSION_TIME - this.EXPLOSION_OFFSET));
        });
    }

    public skipIn() {
        this.destroy();
        RevolverWinTransitions.blastLeft.emit = false;
        RevolverWinTransitions.blastRight.emit = false;
        RevolverWinTransitions.explodeEmitter.emit = false;

        RevolverWinTransitions.winText.visible = true;
        RevolverWinTransitions.winValue.visible = true;

        this.endlessHover(this.mega);

        SoundManager.customEvent("mega_win");

        this.setTextSize(this.TEXT_ZOOM);

        this.resolveIn();
    }

    public out(): Contract<void> {
        return sequence([
            () => Contract.wrap(() => {
                TweenJS.removeAll(RevolverWinTransitions.winValue.scale);
            }),
            () => this.groupAndAnimateOut(this.mega),
            () => Contract.wrap(() => {
                this.mega.visible = false;
                RevolverWinTransitions.winText.visible = false;
                SoundManager.customEvent("celebration_end");
            }),
            () => FadeOut(RevolverWinTransitions.background, this.BOUNCE_TIME * 0.5),
            () => Contract.wrap(() => {
                RevolverWinTransitions.coinShower.emit = false;
                RevolverWinTransitions.gemShower.emit = false;
            }),
            () => Contract.getTimeoutContract(1000)
        ]);
    }

    public destroy() {
        this.clearTimers();

        TweenJS.removeAll(this.mega.scale);
        TweenJS.removeAll(this.mega);

        super.destroy();
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/integration/revolver/transitions/mega-win-transitions.ts